var map = {
	"./AmericanExpress/Color.svg": 379,
	"./AmericanExpress/Grey.svg": 380,
	"./Mastercard/Color.svg": 381,
	"./Mastercard/Grey.svg": 382,
	"./RuPay/Color.svg": 383,
	"./RuPay/Grey.svg": 384,
	"./Visa/Color.svg": 385,
	"./Visa/Grey.svg": 386
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/svgs/ccp/60 ^\.\/.*\.svg$
// module id = 909
// module chunks = 0